import { merge } from '../../helper';

import * as exElement from '../../utils/element';

import type { IBadgeConfig, TypeBadgeBuild } from './types';

// ----------------------------------------------------------------------------

function create(config: IBadgeConfig = {}): HTMLElement {
    // Default Config
    const defConfig = {
        type: 'default',
    };

    // Merge
    merge(defConfig, config);

    // ------------------------------------------------------------------------

    //
    const builds = {
        element: {},
    } as TypeBadgeBuild;

    // ------------------------------------------------------------------------

    // Create element (span)
    const elSpan = exElement.create({
        merge: defConfig,
        tag: 'span',
        class: {
            new: 'badge bg-' + defConfig.type,
        },
    });
    builds.element = elSpan;

    // ------------------------------------------------------------------------

    // Return
    return builds.element;
}

// ----------------------------------------------------------------------------

export { create };
